import auth from "./auth.json";
import dashboard from "./dashboard.json";
import footer from "./footer.json";
import info from "./info.json";

const resources = {
  auth,
  dashboard,
  footer,
  info,
};

export default resources;
